const About = [
  {
    id: 1,
    icon: <i class="fab fa-html5"></i>,
    color: "rgb(227, 76, 38)",
    name: "HTML5",
  },
  {
    id: 2,
    icon: <i class="fab fa-css3-alt"></i>,
    color: "rgb(38, 77, 228)",
    name: "CSS3",
  },
  {
    id: 3,
    icon: <i class="fab fa-bootstrap"></i>,
    color: "rgb(2, 117, 216)",
    name: "Bootstrap5",
  },
  {
    id: 4,
    icon: <i class="fab fa-js-square"></i>,
    color: "rgb(240, 219, 79)",
    name: "JavaScript",
  },
  {
    id: 5,
    icon: <i class="fab fa-react"></i>,
    color: "rgb(97, 219, 251)",
    name: "React",
  },
  {
    id: 6,
    icon: <i class="fab fa-node"></i>,
    color: "rgb(104, 160, 99)",
    name: "Node",
  },
  {
    id: 7,
    icon: <i class="fab fa-node-js"></i>,
    color: "rgb(60, 135, 58)",
    name: "Express.js",
  },
  {
    id: 8,
    icon: <i class="fab fa-git-square"></i>,
    color: "rgb(243, 79, 41)",
    name: "Git",
  },
  {
    id: 9,
    icon: <i class="fab fa-github"></i>,
    color: "white",
    name: "GitHub",
  },
  //   {
  //     id: 10,
  //     icon: ,
  //   },
  //   {
  //     id: 11,
  //     icon: ,
  //   },
  //   {
  //     id: 12,
  //     icon: <i class="fab fa-html5"></i>,
  //   },
  //   {
  //     id: 13,
  //     icon: <i class="fab fa-html5"></i>,
  //   },
  //   {
  //     id: 14,
  //     icon: <i class="fab fa-html5"></i>,
  //   },
  //   {
  //     id: 15,
  //     icon: <i class="fab fa-html5"></i>,
  //   },
];

export default About;
